import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        leftMenu: [],
        component: {
            btnStart: true,
            intro: false,
            recommend: false,
            leftMenu: false,
            map: false,
            imageList: false,
            aboutUs: false,
            news: false,
        },
        topMenu: [
            {name: "非遗图谱", selected: true, isReload: true},
            {name: "资讯中心", selected: false, isReload: false,link:"/news/list"},
            {name: "关于我们", selected: false, isReload: false, link:"/about_us"},
        ],
        logoColor: "#fff",
        projectOpened: false,//项目是否处于打开状态
        media: {
            image: false,
            movie: false,
            audio: false,
        },
        blurBg: false,//背景图片毛玻璃
        currProject: '',
        projectDetails: {
            images_list: [],
            files_list: [],
            media_list: [],
            successor_list: [],
        },
        currCity: "",//当前城市
        showContent: false,//是否展示相关内容,
        loadingContent: false,
        currContentMenu: {},
        showPreview: false,
        currMediaIndex: 0,
        baseConfig: {},
        projectIntro: {
            content: "",
            show: false,
        }
    },
    getters: {
        component: state => {
            return state.component;
        },
        logoColor: state => {
            return state.logoColor;
        },
        projectOpened: state => {
            return state.projectOpened;
        },
        media: state => {
            return state.media;
        },
        blurBg: state => {
            return state.blurBg
        },
        projectDetails: state => {
            return state.projectDetails
        },
        currProject: state => {
            return state.currProject
        },
        currCity: state => {
            return state.currCity
        },
        showContent: state => {
            return state.showContent
        },
        loadingContent: state => {
            return state.loadingContent
        },
        currContentMenu: state => {
            return state.currContentMenu
        },
        showPreview: state => {
            return state.showPreview;
        },
        currMediaIndex: state => {
            return state.currMediaIndex;
        },
        baseConfig: state => {
            return state.baseConfig;
        },
        projectIntro: state => {
            return state.projectIntro;
        },
        topMenu: state => {
            return state.topMenu;
        }
    },
    mutations: {
        componentsSwitch: (state, componentName) => {
            // 变更状态
            state.component[componentName.name] = componentName.status;
        },
        mediaSwitch: (state, mediaName) => {
            // 变更状态
            state.media[mediaName.name] = mediaName.status;
        },
        changeLogoColor: (state, color) => {
            state.logoColor = color;
        },
        projectSwitch: (state) => {
            state.projectOpened = !state.projectOpened;
        },
        bgBlurSwitch: (state, isBlur) => {
            state.blurBg = isBlur;
        },
        setCurrProject: (state, projectId) => {
            state.currProject = projectId;
        },
        setProjectDetails: (state, projectDetails) => {
            state.projectDetails = projectDetails;
        },
        setCurrCity: (state, city) => {
            state.currCity = city;
        },
        closeProject: (state) => {
            state.projectOpened = false;
        },
        setShowContent: (state, showContent) => {
            state.showContent = showContent;
        },
        setLoadingContent: (state, loading) => {
            state.loadingContent = loading;
        },
        setCurrContentMenu: (state, currContentMenu) => {
            state.currContentMenu = currContentMenu;
        },
        setShowPreview: (state, showStatus) => {
            state.showPreview = showStatus;
        },
        setCurrMediaIndex: (state, currIndex) => {
            state.currMediaIndex = currIndex;
        },
        setBaseConfig: (state, baseConfig) => {
            state.baseConfig = baseConfig;
        },
        setProjectIntro: (state, projectIntro) => {
            state.projectIntro = projectIntro;
        },
        setTopMenu: (state, topMenu) => {
            state.topMenu = topMenu;
        },
        openAboutUs: (state) => {
            for (let i in  state.component) {
                if (i === 'aboutUs') {
                    state.component[i] = true;
                } else {
                    state.component[i] = false;
                }
            }
        },
        openNews: (state) => {
            for (let i in  state.component) {
                if (i === 'news') {
                    state.component[i] = true;
                } else {
                    state.component[i] = false;
                }
            }
        }
    }
    ,
})
